<template lang="html">
  <div style="width: 100%; display: flex; justify-content: center;">
    <v-btn
      @click="signInWithMicrosoft"
      :loading="loading"
      :disabled="loading"
      outlined
      class="microsoft-signin-btn"
    >
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="margin-right: 8px; display: inline-block; vertical-align: middle;"
      >
        <rect x="0" y="0" width="10" height="10" fill="#F25022" />
        <rect x="11" y="0" width="10" height="10" fill="#7FBA00" />
        <rect x="0" y="11" width="10" height="10" fill="#00A4EF" />
        <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
      </svg>
      Sign in with Microsoft
    </v-btn>
  </div>
</template>

<script>
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../utils/sso-msal";

export default {
  emits: ['showError', 'sso:microsoft'],
  data() {
    return {
      loading: false,
      msalInstance: null,
    };
  },
  mounted() {
    this.initializeMSAL();
  },
  methods: {
    async initializeMSAL() {
      this.msalInstance = new PublicClientApplication(msalConfig);
      await this.msalInstance.initialize();
    },
    async signInWithMicrosoft() {
      this.loading = true;

      try {
        if (!this.msalInstance) {
          await this.initializeMSAL();
        }

        const loginRequest = {
          scopes: ["openid", "profile", "email", "User.Read"],
          prompt: "select_account",
        };

        const response = await this.msalInstance.loginPopup(loginRequest);
        if (response && response.accessToken) {
          this.$emit('loginMicrosoft', response)
        }
      } catch (error) {
        // Extract user-friendly error message
        let errorMessage = "Failed to sign in with Microsoft. Please try again.";
        
        if (error.errorCode) {
          if (error.errorCode === "AADSTS50020") {
            errorMessage = "Your Microsoft account is not authorized to access this application. Please contact your administrator or use a different account.";
          } else if (error.errorCode === "AADSTS50058") {
            errorMessage = "The user account has been disabled. Please contact your administrator for assistance.";
          } else if (error.errorCode === "AADSTS50076") {
            errorMessage = "The user account has expired. Please contact your administrator for assistance.";
          } else if (error.errorCode === "AADSTS50079") {
            errorMessage = "The user account has been locked out. Please contact your administrator for assistance.";
          } else if (error.errorCode === "AADSTS50085") {
            errorMessage = "The user account has been deleted. Please contact your administrator for assistance.";
          } else if (error.errorCode === "AADSTS50126") {
            errorMessage = "Invalid or missing password: password does not exist in the directory for this user.";
          } else if (error.errorCode === "user_cancelled") {
            errorMessage = "Sign in was cancelled.";
            return; // Don't show error for user cancellation
          } else {
            errorMessage = `Microsoft sign-in error: ${error.errorMessage || error.errorCode}`;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        this.$emit("showError", errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.microsoft-signin-btn {
  width: 240px;
  height: 37px;
  text-transform: none;
  border: 1px solid #d1d5db;
  background-color: #ffffff;
  color: #1f2937 !important;
  font-weight: 500;
  font-family: revert;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.microsoft-signin-btn:hover {
  background-color: hsl(218, 81.8%, 96.9%);
  /* border-color: #9ca3af; */
  border-color: hsl(218, 81.8%, 56.9%);
}

.microsoft-signin-btn svg {
  flex-shrink: 0;
}
</style>
